import type {
  AdminCatalogTypeUpdateRequest,
  AdminCatalogVariantUpdateRequest,
} from "@pufimi/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogView } from "@/components/catalog/catalog-view";
import { adminCatalogQueryKey } from "@/lib/admin-queries";
import { adminApi } from "@/lib/api";

function CatalogRoute() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: adminCatalogQueryKey(),
    queryFn: () => adminApi.catalog.list(),
  });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: adminCatalogQueryKey() });

  const typeMutation = useMutation({
    mutationFn: ({ id, body }: { id: string; body: AdminCatalogTypeUpdateRequest }) =>
      adminApi.catalog.updateType(id, body),
    onSuccess: invalidate,
  });
  const variantMutation = useMutation({
    mutationFn: ({ id, body }: { id: string; body: AdminCatalogVariantUpdateRequest }) =>
      adminApi.catalog.updateVariant(id, body),
    onSuccess: invalidate,
  });

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Katalog</h1>
        <p className="text-muted-foreground">
          Typy produktów i ich warianty. Zmiany działają od razu w nowych wycenach, bez wdrożenia —
          i nie zmieniają kwot już złożonych zamówień. Wyłączenie typu ukrywa go przed kupującymi.
        </p>
      </header>

      {query.isPending ? (
        <p className="text-sm text-muted-foreground">Ładowanie…</p>
      ) : query.isError ? (
        <p className="text-sm text-destructive">Nie udało się wczytać katalogu.</p>
      ) : (
        <CatalogView
          types={query.data.types}
          onSaveType={async (id, body) => {
            await typeMutation.mutateAsync({ id, body });
          }}
          onSaveVariant={async (id, body) => {
            await variantMutation.mutateAsync({ id, body });
          }}
        />
      )}
    </div>
  );
}

export const Route = createFileRoute("/catalog/")({ component: CatalogRoute });
